import cn from "classnames";
import { Box, Typography } from "@mui/material";

import ChatbotBody from "./components/ChatbotBody";
import ChatbotFooter from "./components/ChatbotFooter";
import ChatbotHeader from "./components/ChatbotHeader";
import useStyles from "./Chatbot.styles";

import { IBalanceCandidate, IBalanceSituation } from "services/ai";

import useChatbot from "./useChatbot";

const Chatbot = ({
    candidatesPayload,
    situationPayload,
}: {
    candidatesPayload: IBalanceCandidate[];
    situationPayload: IBalanceSituation | null;
}) => {
    const classes = useStyles();

    const {
        openChatbox,
        isLoading,
        isOnline,
        sizeMode,
        messages,
        messageInput,
        setMessageInput,
        handleOpenChatbox,
        handleCloseChatbox,
        handleToggleMaximize,
        handleToggleCompactSize,
        handleSendMessage,
        handleAbortMessage,
    } = useChatbot(candidatesPayload, situationPayload);

    return (
        <Box
            className={cn(classes.chatbot, {
                [classes.chatbotCompact]: sizeMode === "compact",
                [classes.chatbotOpenCompact]: sizeMode === "compact" && openChatbox,
                [classes.chatbotMaximized]: sizeMode === "maximized",
            })}
        >
            <ChatbotHeader
                isOpen={openChatbox}
                isOnline={isOnline}
                onCloseChatbox={handleCloseChatbox}
                onOpenChatbox={handleOpenChatbox}
                onMaximizeChatbox={handleToggleMaximize}
                onCompactChatbox={handleToggleCompactSize}
                isCompact={sizeMode === "compact"}
            />

            {openChatbox && (
                <>
                    <ChatbotBody
                        messages={messages}
                        isLoading={isLoading}
                        isOnline={isOnline}
                        shouldFillHeight={sizeMode === "maximized" || sizeMode === "compact"}
                    />
                    <ChatbotFooter
                        isOnline={isOnline}
                        isLoading={isLoading}
                        message={messageInput}
                        messages={messages}
                        onMessageChange={setMessageInput}
                        onSendMessage={handleSendMessage}
                        onAbortMessage={handleAbortMessage}
                    />
                </>
            )}

            {openChatbox && (
                <Box className={classes.escapeHint}>
                    <Typography className={classes.escapeHintText}>Press</Typography>
                    <Box className={classes.escapeKeyContainer}>
                        <Typography className={classes.escapeHintText}>ESC</Typography>
                    </Box>
                    <Typography className={classes.escapeHintText}>to close</Typography>
                </Box>
            )}
        </Box>
    );
};

export default Chatbot;
